import React,{Component} from 'react';
import $ from 'jquery';

class LandHeader extends Component{
  componentDidMount(){
      const headerArea = $('.header-area').attr('class');
      console.log(headerArea);
  }
  render(){
    return (
      <header className="header-area header-bg-2" id="home">
          <div className="container">
              <div className="row justify-content-center">
                  <div className="col-md-7 col-md-offset-3">
                      <div className="header-inner">
                          <h1 className="title wow fadeInDown">Showcase Your App With Apptidy</h1>
                          <p>Apprtidy is the best app landing page which will help you showcase your business, lifestyle, social, or shopping app in the best possible manner.</p>
                          <div className="btn-wrapper wow fadeInUp">
                              <a href="https://themeforest.net/item/apptidy-app-landing-page/22930538"  target="_blank" rel="noopener noreferrer" className="boxed-btn btn-rounded"> Purchase</a>
                              <a href="#explore" className="boxed-btn btn-rounded blank"> Explore Now</a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </header>
    )
  }
}

export default LandHeader;
